import { ComponentPropsWithoutRef } from "react";
import { twMerge } from "tailwind-merge";
import { getScheduleDateParts } from "./getScheduleDateParts";

interface IScheduleDateBadgeProps extends ComponentPropsWithoutRef<"div"> {
  diaAgendado?: string | null;
  horaAgendada?: string | null;
}

const BASE_CLASSNAME =
  "flex flex-row items-center justify-center gap-2 rounded-[10px] border border-[#e5e5ea] bg-[#fafcfe] py-2.5 sm:flex-col sm:w-[95px] sm:min-h-[90px] sm:gap-1";

export const ScheduleDateBadge = ({
  diaAgendado,
  horaAgendada,
  className,
  ...rest
}: IScheduleDateBadgeProps) => {
  if (!diaAgendado) {
    return (
      <div
        {...rest}
        className={twMerge(BASE_CLASSNAME, "border-dashed", className)}
      >
        <img
          src="/assets/svgs/icon-calendar-lock.svg"
          alt=""
          className="h-5 w-5"
        />
        <span className="text-center font-['Mulish'] text-[10px] text-[#2d2d2d]">
          Não Definido
        </span>
      </div>
    );
  }

  const { month, day } = getScheduleDateParts(diaAgendado);

  return (
    <div
      {...rest}
      className={twMerge(BASE_CLASSNAME, "border-solid", className)}
    >
      <span className="font-['Mulish'] text-[10px] text-[#20332f]">
        {month}
      </span>
      <span className="font-['Mulish'] text-xl font-extrabold text-[#2d2d2d]">
        {day}
      </span>
      <span className="font-['Mulish'] text-sm text-[#2d2d2d]">
        {horaAgendada}
      </span>
    </div>
  );
};
